export const mapGradient = (gradient: { dir: string; colors: Array<string> }, type?: string) => {
    return type === "radial"
        ? `radial(${gradient.colors.map((color) => {
              return color;
          })})`
        : `linear(${gradient.dir}, ${gradient.colors.map((color) => {
              return color;
          })})`;
};
